(function () {
  'use strict';

  function init() {
    var bubble = document.querySelector('[data-pvb-bubble]');
    var modal = document.querySelector('[data-pvb-modal]');
    if (!bubble || !modal) return;

    initBubblePreview(bubble);
    initDraggableBubble(bubble, modal);
    initModal(modal);
  }

  // Lazy-load and play the tiny looping preview inside the bubble
  function initBubblePreview(bubble) {
    var video = bubble.querySelector('[data-pvb-bubble-video]');
    if (!video) return;

    var source = video.querySelector('source[data-src]');
    if (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
      video.load();
    }
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {
        /* Autoplay blocked — bubble still shows the poster frame, harmless */
      });
    }
  }

  // Pointer-based dragging with a movement threshold so a plain tap
  // (no meaningful movement) still opens the modal instead of being
  // swallowed as a drag.
  function initDraggableBubble(bubble, modal) {
    var closeBtn = bubble.querySelector('[data-pvb-close]');

    function pinToTopLeft() {
      var rect = bubble.getBoundingClientRect();
      bubble.style.left = rect.left + 'px';
      bubble.style.top = rect.top + 'px';
      bubble.style.right = 'auto';
      bubble.style.bottom = 'auto';
    }

    function clampToViewport() {
      var rect = bubble.getBoundingClientRect();
      var maxLeft = window.innerWidth - rect.width - 8;
      var maxTop = window.innerHeight - rect.height - 8;
      var left = Math.min(Math.max(8, rect.left), maxLeft);
      var top = Math.min(Math.max(8, rect.top), maxTop);
      bubble.style.left = left + 'px';
      bubble.style.top = top + 'px';
    }

    window.requestAnimationFrame(pinToTopLeft);
    window.addEventListener('resize', clampToViewport);

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startY = 0;
    var originLeft = 0;
    var originTop = 0;

    bubble.addEventListener('pointerdown', function (e) {
      if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      var rect = bubble.getBoundingClientRect();
      originLeft = rect.left;
      originTop = rect.top;
      bubble.setPointerCapture(e.pointerId);
    });

    bubble.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;

      var rect = bubble.getBoundingClientRect();
      var maxLeft = window.innerWidth - rect.width - 4;
      var maxTop = window.innerHeight - rect.height - 4;
      var newLeft = Math.min(Math.max(4, originLeft + dx), maxLeft);
      var newTop = Math.min(Math.max(4, originTop + dy), maxTop);

      bubble.style.left = newLeft + 'px';
      bubble.style.top = newTop + 'px';
      bubble.style.right = 'auto';
      bubble.style.bottom = 'auto';
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      if (!moved) {
        trackVideoBubbleClick(bubble.getAttribute('data-product-id') || '');
        openModal(modal);
      }
    }

    bubble.addEventListener('pointerup', endDrag);
    bubble.addEventListener('pointercancel', endDrag);

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        bubble.hidden = true;
      });
    }
  }

  // Same dataLayer / Meta Pixel pattern as the video carousels — safe
  // no-op if either tool isn't installed on the site.
  function trackVideoBubbleClick(productId) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', 'video_carousel_click', {
          video_source: 'product_bubble',
          product_id: productId
        });
      }
    } catch (e) {
      /* gtag unavailable — ignore */
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_carousel_click',
        video_source: 'product_bubble',
        product_id: productId
      });
    } catch (e) {
      /* dataLayer unavailable — ignore */
    }

    try {
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'VideoCarouselClick', {
          source: 'product_bubble',
          product_id: productId
        });
      }
    } catch (e) {
      /* Meta Pixel unavailable — ignore */
    }
  }

  function openModal(modal) {
    modal.hidden = false;
    var video = modal.querySelector('[data-pvb-modal-video]');
    if (!video) return;

    var source = video.querySelector('source[data-src]');
    if (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
      video.load();
    }
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {});
    }
  }

  function closeModal(modal) {
    modal.hidden = true;
    var video = modal.querySelector('[data-pvb-modal-video]');
    if (video) video.pause();
  }

  function initModal(modal) {
    var closeBtn = modal.querySelector('[data-pvb-modal-close]');
    var muteBtn = modal.querySelector('[data-pvb-mute]');
    var video = modal.querySelector('[data-pvb-modal-video]');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    // Tapping the dark backdrop (not the player itself) closes it
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });

    if (muteBtn && video) {
      var iconMuted = muteBtn.querySelector('[data-pvb-icon-muted]');
      var iconUnmuted = muteBtn.querySelector('[data-pvb-icon-unmuted]');

      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        if (iconMuted && iconUnmuted) {
          iconMuted.style.display = video.muted ? '' : 'none';
          iconUnmuted.style.display = video.muted ? 'none' : '';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();